import { isMobileDevice } from 'Utilities/devices';
import { User } from 'Utilities/user/@types';

export const optimizelyAttributes = ({ user, ...attributes }: { user?: Partial<User> | null }) => ({
  isMobile: isMobileDevice({}),
  userAgent: globalThis?.navigator?.userAgent || null,
  userId: user?.id ? user.id.toString() : null,
  ...attributes,
});
